<div class="datetime-picker" [class]="customClass()" cdkOverlayOrigin #origin="cdkOverlayOrigin">
  <input test-id="datetime-picker-ctrl"
         [id]="id"
         [attr.aria-labelledby]="id + 'datetime-picker-ctrl-label'"
         class="datetime-picker-ctrl"
         type="text"
         [value]="value$ | async"
         [ngModel]="value$ | async"
         [name]="name()"
         [mask]="mask()"
         [patterns]="patterns"
         [dropSpecialCharacters]="false"
         (change)="setDateTime($event)"
         (input)="onInputChange($event)"
         (blur)="blur()"
         [placeholder]="placeholder()"
         [disabled]="isDisabled()"
         autocomplete="off">

  <label [id]="id + 'datetime-picker-ctrl-label'" [for]="id" class="datetime-picker-icon" (click)="openDatePicker()"></label>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
  [cdkConnectedOverlayPanelClass]="panelClass()"
  (overlayKeydown)="onOverlayKeydown($event)"
  (backdropClick)="close()"
  (detach)="close()">
  <div class="ms-datepicker-calendar">
    <div class="ms-datepicker-nav">
      <button type="button" class="ms-datepicker-nav-left" aria-label="Previous" (click)="onLeftNav()"></button>

      <div class="ms-datepicker-header">
        @if (!isMonthMode()) {
          <span class="month">{{displayMonth}}</span>
        }
        <div class="year">
          @if (isYearActive) {
            <input type="number" maxlength="4" class="ctrl" aria-label="Year"
                   [(ngModel)]="displayYear" (change)="setDisplayYear()" (blur)="deactivateYear()"/>
          } @else {
            <span class="value" role="button" tabindex="0" aria-label="Edit year"
                  (click)="activateYear()" (keydown.enter)="activateYear()" (keydown.space)="activateYear()">{{displayYear}}</span>
          }
        </div>
      </div>

      <button type="button" class="ms-datepicker-nav-right" aria-label="Next" (click)="onRightNav()"></button>
    </div>

    <mat-calendar
      [startAt]="activeDate()"
      [selected]="selectedDate()"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
      [startView]="startView()"
      (selectedChange)="onCalendarSelect($event)"
      (monthSelected)="onMonthSelected($event)"></mat-calendar>

    @if (hasTime()) {
      <div class="ms-datepicker-time">
        <div class="hours">
          @if (isHoursActive) {
            <input class="ctrl" max="12" mask="00" aria-label="Hours"
                   [ngModel]="hours" (blur)="onHoursBlur($event)"/>
          } @else {
            <span class="value" role="button" tabindex="0" aria-label="Edit hours"
                  (click)="activateHours()" (keydown.enter)="activateHours()">{{hours | datetimeTime}}</span>
          }
        </div>

        <span class="separator">:</span>

        <div class="minutes">
          @if (isMinutesActive) {
            <input class="ctrl" max="60" mask="00" aria-label="Minutes"
                   [ngModel]="minutes" (blur)="onMinutesBlur($event)"/>
          } @else {
            <span class="value" role="button" tabindex="0" aria-label="Edit minutes"
                  (click)="activateMinutes()" (keydown.enter)="activateMinutes()">{{minutes | datetimeTime}}</span>
          }
        </div>

        <span class="meridiem" role="button" tabindex="0" aria-label="Toggle AM or PM"
              (click)="toggleMeridiem()" (keydown.enter)="toggleMeridiem()">{{meridiem}}</span>
      </div>
    }
  </div>
</ng-template>
